module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_bottom_white-c0032751c7949a5311f714133711fd42.svg";